// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","colorWhite":"#fff","colorBrand":"#5a5ae6","colorBrandLight":"#6b6bf2","colorBrandDark":"undefined","colorBlackA30":"rgba(14, 19, 24, 0.3)","colorBlackA10":"rgba(14, 19, 24, 0.1)","colorBlackA07":"rgba(14, 19, 24, 0.07)","colorRed":"#f05663","colorRedLight":"#f76572","fontNormal":"_2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","mediumFontWeight":"500","button":"_3syXWfWNnRF8XESkvvzfVv _2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","primary":"_3WbImVjgIyVDZKIgtYQG8l","secondary":"_1ZYpuAxMH40ZMWvc30U0ja","tertiary":"_3lBpMHChyE3B0zAxDAOObL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/button/button.css
// module id = 917
// module chunks = 0